module.exports = __webpack_public_path__ + "static/media/myrso-help.ebf2a19d.svg";